<template>
  <v-btn :to="`/${$i18n.locale}/register`" text>
    {{ $t("appbar.signup") }}
  </v-btn>
</template>

<script>
export default {
  name: 'register'
};
</script>